import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import Helmet from 'react-helmet';
import { getFBAdPreview } from 'redux/modules/adBuilder';
import { getPageStats, getRecentPosts, getPageInsights, getAds } from 'redux/modules/reportSocialMediaSummary';
import { ListItem } from 'material-ui/List';
import { LeftNavLayout } from 'containers';
import { SocialMediaSummaryPreview, FacebookChecklistPreview, UpcomingContentPreview } from 'containers/ReportBuilder';
import { EmptyState, PageHeader, Spinner } from 'components';
import * as styles from './ReportBuilder.scss';
var Preview = (_dec = connect(function (state, props) {
  return {
    organization: state.organization.current,
    searchingOrgs: state.auth.searchingOrganizations,
    selectedClient: state.reportBuilder.selectedClient,
    theme: state.theme,
    partnerTheme: state.reportBuilder.partnerTheme,
    gettingPartnerTheme: state.reportBuilder.gettingPartnerTheme,
    usePartnerBranding: state.reportBuilder.usePartnerBranding,
    socialMediaSummaryTemplate: state.reportSocialMediaSummary,
    facebookChecklistTemplate: state.reportFacebookChecklist,
    upcomingContentTemplate: state.reportUpcomingContent,
    reportTitle: state.reportBuilder.reportTitle,
    startDate: state.reportBuilder.startDate,
    endDate: state.reportBuilder.endDate
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Preview, _Component);

  var _super = _createSuper(Preview);

  function Preview() {
    var _this;

    _classCallCheck(this, Preview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderSection", function (section, innerStuff) {
      var colors = {
        primaryColor: _this.props.usePartnerBranding && _this.props.partnerTheme ? _this.props.partnerTheme.details.primaryColor : '#ef7521',
        secondaryColor: _this.props.usePartnerBranding && _this.props.partnerTheme ? _this.props.partnerTheme.details.secondaryColor : '#1f5180'
      };
      return /*#__PURE__*/React.createElement("div", {
        className: styles.previewSectionWrap,
        key: section.key
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.previewSectionHeaderWrap,
        style: {
          borderBottom: "1px solid ".concat(colors.primaryColor)
        }
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.previewSectionHeader,
        style: {
          color: colors.primaryColor
        }
      }, section.label)), /*#__PURE__*/React.createElement("div", {
        className: styles.previewSectionContentWrap
      }, innerStuff));
    });

    return _this;
  }

  _createClass(Preview, [{
    key: "render",
    value: function render() {
      var colors = {
        primaryColor: this.props.usePartnerBranding && this.props.partnerTheme ? this.props.partnerTheme.details.primaryColor : '#ef7521',
        secondaryColor: this.props.usePartnerBranding && this.props.partnerTheme ? this.props.partnerTheme.details.secondaryColor : '#1f5180'
      };
      var logoUrl = this.props.usePartnerBranding && this.props.partnerTheme ? this.props.partnerTheme.details.logoUrl[0] : 'https://likeabucket.s3.amazonaws.com/76q7m7c40g_1480436487184.png';
      var previewInnards;
      previewInnards = /*#__PURE__*/React.createElement(SocialMediaSummaryPreview, {
        colors: colors,
        renderSection: this.renderSection,
        template: this.props.template.details ? this.props.template.details : this.props.socialMediaSummaryTemplate
      });

      if (this.props.reportType === 'facebookChecklist') {
        previewInnards = /*#__PURE__*/React.createElement(FacebookChecklistPreview, {
          partnerTheme: this.props.partnerTheme,
          colors: colors,
          renderSection: this.renderSection,
          template: this.props.template.details ? this.props.template.details : this.props.facebookChecklistTemplate
        });
      } else if (this.props.reportType === 'upcomingContent') {
        previewInnards = /*#__PURE__*/React.createElement(UpcomingContentPreview, {
          partnerTheme: this.props.partnerTheme,
          colors: colors,
          renderSection: this.renderSection,
          template: this.props.template.details ? this.props.template.details : this.props.upcomingContentTemplate
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          overflow: 'auto',
          paddingBottom: 24,
          flex: '2 1 65%',
          marginLeft: 12,
          paddingRight: 12
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          border: "2px solid ".concat(colors.primaryColor)
        },
        className: styles.previewWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.previewLogoRow
      }, /*#__PURE__*/React.createElement("img", {
        className: styles.previewLogo,
        src: logoUrl
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.createdDate
      }, "Report generated:", ' ', this.props.template.updatedAt ? moment(this.props.template.updatedAt).format('MM/DD/YYYY') : moment().format('MM/DD/YYYY'))), /*#__PURE__*/React.createElement("div", {
        className: styles.previewHeaderRow
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.previewTitlePrimary
      }, this.props.selectedClient ? this.props.selectedClient.name : ''), /*#__PURE__*/React.createElement("h3", {
        className: styles.previewTitleSecondary
      }, this.props.reportTitle), this.props.reportType === 'socialMediaSummary' && /*#__PURE__*/React.createElement("h4", {
        className: styles.previewSubtitle
      }, this.props.startDate && this.props.endDate && "".concat(moment(this.props.startDate).format('MM/DD/YYYY'), " - ").concat(moment(this.props.endDate).format('MM/DD/YYYY'))), this.props.reportType === 'upcomingContent' && /*#__PURE__*/React.createElement("h4", {
        className: styles.previewSubtitle
      }, this.props.startDate && this.props.endDate && "".concat(moment(this.props.startDate).format('MM/DD/YYYY'), " - ").concat(moment(this.props.endDate).format('MM/DD/YYYY')))), previewInnards));
    }
  }]);

  return Preview;
}(Component)) || _class);
export { Preview as default };
Preview.defaultProps = {
  template: false
};